module.exports = __webpack_public_path__ + "static/media/ic-arrow-left.74107362.svg";